module.exports = __webpack_public_path__ + "static/img/3.e97adc2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/sp/3.png
// module id = ghUx
// module chunks = 0